module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/beginnerkun/node_modules/_axios@0.19.0@axios/index.js
// module id = DxpJ
// module chunks = 1